/* CUSTOMDO premium sections — scroll reveal (respects reduced motion) */
(function () {
  function init() {
    var els = document.querySelectorAll('.cd-reveal, .cdx-reveal');
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('cd-in'); });
      return;
    }
    var io = new IntersectionObserver(function (ent) {
      ent.forEach(function (x) {
        if (x.isIntersecting) { x.target.classList.add('cd-in'); io.unobserve(x.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
